<template>
    <div>
        <div>
            <div>
                <div style="display: flex;justify-content: flex-start">
                    <el-input placeholder="生码编号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductCodes"
                              style="width: 150px" v-model="searchValue.generateCodeId"
                              @keydown.enter.native="initProductCodes"></el-input>
                    <el-input placeholder="批次编号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductCodes"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.codeBatchId"
                              @keydown.enter.native="initProductCodes"></el-input>
                    <el-input placeholder="码流水号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductCodes"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.codeBatchSerialNumber"
                              @keydown.enter.native="initProductCodes"></el-input>
                    <el-input placeholder="产品名称" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductCodes"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productName"
                              @keydown.enter.native="initProductCodes"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initProductCodes"
                               style="margin-left: 10px">
                        搜索
                    </el-button>
                </div>
                <div style="display: flex;justify-content: flex-start; margin-top: 10px">
                    <el-button type="primary" icon="el-icon-plus" @click="showAddProductCodeView">
                        产品赋码
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    ref="productCodeTable"
                    :data="productCodes"
                    stripe
                    border
                    width="100%"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    style="width: 100%">
                <el-table-column
                        prop="productCodeId"
                        align="center"
                        label="赋码编号"
                        min-width="7%">
                </el-table-column>
                <el-table-column
                        prop="codeBatchId"
                        label="码批次号"
                        align="center"
                        min-width="8%">
                </el-table-column>
                <el-table-column
                        prop="codeBatchCodeNumber"
                        label="批次码量"
                        align="center"
                        min-width="8%">
                </el-table-column>
                <el-table-column
                        prop="productBatchTitle"
                        label="产品批次"
                        align="center"
                        min-width="10%">
                </el-table-column>
                <el-table-column
                        prop="productId,productCode"
                        label="产品编号/代码"
                        min-width="14%"
                        align="center">
                    <template slot-scope="scope">
                        <span style="color: #008000">
                            {{scope.row.productId}}
                        </span>
                        /
                        <span style="color: #008000">
                            {{scope.row.productCode}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="productName"
                        label="产品名称"
                        min-width="20%"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="productCodeMemo"
                        label="赋码说明"
                        min-width="20%"
                        align="center">
                </el-table-column>
                <el-table-column
                        min-width="15%"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="deleteProductCode(scope.row)" style="padding: 3px" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
            <div style="padding: 25px">
                <div class="templateBottom">
                    <p style="height: 8px">说明:</p>
                    <p style="height: 5px">1.</p>
                    <p style="height: 5px">2.</p>
                    <p style="height: 5px">3.</p>
                </div>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogAddVisible"
                width="80%">
            <div>
                <el-form :model="productCode" :rules="rules" ref="productCodeAddForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="生码批次:" style="width: 350px" prop="codeBatchId">
                            <el-select v-model="productCode.codeBatchId" clearable placeholder="请选择批次">
                                <el-option
                                        v-for="item in codeBatchs"
                                        :key="item.codeBatchId"
                                        :label="item.codeBatchId"
                                        :value="item.codeBatchId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="赋码说明:" prop="productCodeMemo" style="padding-left: 10px">
                            <el-input size="mini" type="textarea" style="width: 300px" prefix-icon="el-icon-edit" v-model="productCode.productCodeMemo"
                                      placeholder="请输入赋码说明"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="产品名称:" style="width: 350px" prop="productId">
                            <el-select v-model="productCode.productId"
                                       clearable
                                       @change="productIdChanged"
                                       placeholder="请选择产品">
                                <el-option
                                        v-for="item in products"
                                        :key="item.productId"
                                        :label="item.productName"
                                        :value="item.productId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品批次:" style="width: 350px; padding-left: 30px" prop="productBatchId">
                            <el-select v-model="productCode.productBatchId" clearable placeholder="请选择产品批次">
                                <el-option
                                        v-for="item in productBatchs"
                                        :key="item.productBatchId"
                                        :label="item.productBatchTitle"
                                        :value="item.productBatchId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProductCode(productCode)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    const axios = require('axios');
    export default {
        name: "QRMProductCode",
        inject: ['reload'],
        data() {
            return {
                searchValue: {
                    generateCodeId: null,
                    codeBatchId: null,
                    codeBatchSerialNumber: '',
                    productName: ''
                },
                title: '',
                products: [],
                codeBatchs: [],
                productBatchs: [],
                productCodes: [],
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                action: '',
                dialogAddVisible: false,
                productCode: {
                    codeBatchId: null,
                    productId: null,
                    productBatchId: null,
                    productCodeMemo: ''
                },
                rules: {
                    codeBatchId: [{required: true, message: '请选择码批次', trigger: 'blur'}],
                    productId: [{required: true, message: '请选择产品', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.initProductCodes();
        },
        watch:{
            total(){
                if(this.total==(this.page-1)*this.size && this.total!=0){
                    this.page-=1;
                    this.initProductBatchs();//获取列表数据
                }
            }
        },
        methods: {
            productIdChanged() {
                if(this.productCode.productId){
                    var param = {
                        productId: this.productCode.productId
                    }
                    this.getProductBatchs(param);
                }else {
                    this.productCode.productBatchId = null;
                    this.productBatchs = [];
                }
            },
            getProducts() {
                this.getRequest('/product/product/list').then(resp => {
                    if (resp) {
                        this.products = resp.data;
                    }
                });
            },
            getProductBatchs(param) {
                this.getRequest('/product/batch/list', param).then(resp => {
                    if (resp) {
                        this.productBatchs = resp.data;
                        if(this.productCode.productBatchId){
                            var find = false;
                            var _this = this;
                            _this.productBatchs.forEach(batch => {
                                if(batch.productBatchId == _this.productCode.productBatchId){
                                    find = true;
                                }
                            })
                            if(!find){
                                _this.productCode.productBatchId = null;
                            }
                        }
                    }
                });
            },
            getCodeBatchs() {
                this.getRequest('/qrm/codebatch/list').then(resp => {
                    if (resp) {
                        this.codeBatchs = resp.data;
                    }
                });
            },
            showAddProductCodeView() {
                this.title = '添加产品赋码信息';
                this.emptyProductCode();
                this.getProducts();
                this.getCodeBatchs();
                this.dialogAddVisible = true;
            },
            addProductCode(productCode) {
                if(productCode){
                    this.$refs['productCodeAddForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/qrm/code/addCheck", productCode).then(resp => {
                                if (resp) {
                                    if(resp.obj.checkResult){
                                        this.postRequest("/qrm/code/add", productCode).then(resp => {
                                            if (resp) {
                                                this.dialogAddVisible = false;
                                                this.initProductCodes();
                                            }
                                        })
                                    }else {
                                        this.$confirm(resp.obj.returnMessage, '提示', {
                                            confirmButtonText: '确定',
                                            cancelButtonText: '取消',
                                            type: 'warning'
                                        }).then(() => {
                                            this.postRequest("/qrm/code/add", productCode).then(resp => {
                                                if (resp) {
                                                    this.dialogAddVisible = false;
                                                    this.initProductCodes();
                                                }
                                            })
                                        }).catch(() => {
                                            this.$message({
                                                type: 'info',
                                                message: '已取消赋码'
                                            });
                                        });
                                    }
                                }
                            })

                        }
                    });
                }
            },
            deleteProductCode(data) {
                this.$confirm('此操作将永久删除【' + data.productCodeId + '】编号赋码, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postRequest("/qrm/code/delete", data).then(resp => {
                        if (resp) {
                            this.initProductCodes();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            emptyProductCode() {
                this.productCode = {
                    codeBatchId: null,
                    productId: null,
                    productBatchId: null,
                    productCodeMemo: ''
                }
            },
            initProductCodes() {
                this.loading = true;
                let url = '/qrm/code/listByPage?page=' + this.page + '&size=' + this.size;
                if (this.searchValue.generateCodeId) {
                    url += '&generateCodeId=' + this.searchValue.generateCodeId;
                }
                if (this.searchValue.codeBatchId) {
                    url += '&codeBatchId=' + this.searchValue.codeBatchId;
                }
                if (this.searchValue.codeBatchSerialNumber) {
                    url += '&codeBatchSerialNumber=' + this.searchValue.codeBatchSerialNumber;
                }
                if (this.searchValue.productName) {
                    url += '&productName=' + this.searchValue.productName;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.productCodes = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initProductBatchs();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initProductBatchs();
            }
        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .templateBottom {
        padding: 10px;
        background-color: #FFFFE0;
        box-sizing: border-box;
    }

    .templateType{
        margin-top: 8px;
    }

    .templateUpload{
        display: flex;
        display: -webkit-flex;
        align-items:center;
        justify-content:center
    }

    .hide .el-upload--picture-card {
        display: none;
    }

</style>